// components/partial/ReopenJobModal.jsx
import React, { Component } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';

class ReopenJobModal extends Component {
  state = {
    reasonCode: '',
    reasonNotes: ''
  };

  reopenReasons = [
    { value: 'closed_wrong_job', label: 'Closed wrong job' },
    { value: 'additional_work_needed', label: 'Additional work needed' },
    { value: 'service_scope_change', label: 'Service scope change' },
    { value: 'other', label: 'Other' }
  ];

  handleReasonChange = (e) => {
    this.setState({ reasonCode: e.target.value });
  };

  handleNotesChange = (e) => {
    this.setState({ reasonNotes: e.target.value });
  };

  handleConfirm = () => {
    if (!this.state.reasonCode) {
      alert('Please select a reason for reopening');
      return;
    }
    this.props.onConfirm({
      reasonCode: this.state.reasonCode,
      reasonNotes: this.state.reasonNotes || null
    });
    this.resetState();
  };

  handleCancel = () => {
    this.props.onHide();
    this.resetState();
  };

  resetState = () => {
    this.setState({ reasonCode: '', reasonNotes: '' });
  };

  render() {
    const { show, request } = this.props;
    const { reasonCode, reasonNotes } = this.state;

    if (!request) return null;

    const vehicleInfo = `${request.vehicleYear || ''} ${request.vehicleMake || ''} ${request.vehicleModel || ''}`.trim();

    return (
      <Modal show={show} onHide={this.handleCancel} centered>
        <Modal.Header closeButton>
          <Modal.Title>Reopen Job</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div className="job-info mb-3 p-3 bg-light rounded" style={{ borderLeft: '4px solid var(--color-warning)' }}>
            <h6 className="mb-1">{vehicleInfo}</h6>
            <p className="text-muted mb-0">{request.serviceRequested}</p>
          </div>

          <div className="alert alert-warning">
            This will delete the draft invoice and reset all services to In Progress.
          </div>

          <Form.Group>
            <Form.Label className="font-weight-bold">
              Reason for Reopening <span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              as="select"
              value={reasonCode}
              onChange={this.handleReasonChange}
              required
            >
              <option value="">-- Select a reason --</option>
              {this.reopenReasons.map(reason => (
                <option key={reason.value} value={reason.value}>
                  {reason.label}
                </option>
              ))}
            </Form.Control>
          </Form.Group>

          <Form.Group className="mt-3">
            <Form.Label className="font-weight-bold">
              Additional Notes <span className="text-muted">(optional)</span>
            </Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              value={reasonNotes}
              onChange={this.handleNotesChange}
              placeholder="Any additional details about why this job is being reopened..."
            />
          </Form.Group>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={this.handleCancel}>
            Cancel
          </Button>
          <Button
            variant="warning"
            onClick={this.handleConfirm}
            disabled={!reasonCode}
          >
            Reopen Job
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default ReopenJobModal;
